<div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (fileDropped)="uploadFile($event)">
  <input hidden type="file" [accept]="accept" #fileInput (change)="uploadFile($event.target.files)">
  <p class="bottom-center">Drag and drop file here; or click to browse...</p>
</div>
